import { Injectable } from '@angular/core';
import { DistributionPassengers } from '../components/offers/distribution-passengers-content-modal/distribution-passengers-content-modal.component';

@Injectable({
  providedIn: 'root'
})
export class DistributionPassengersService {
  showValidation = false;
  hasTooManyInfantsValidation = false;

  /** Obtiene las claves de los datos que representan edades de menores */
  getMinorsAgeKeys(distributionData: DistributionPassengers): string[] {
    return Object.keys(distributionData).filter(key => key.startsWith('minorAge'));
  }

  /** Verifica si existe algún menor sin edad especificada y activa validaciones */
  hasMinorWithoutAge(distributionData: DistributionPassengers): boolean {
    const minorsAgeKeys = this.getMinorsAgeKeys(distributionData);
    return minorsAgeKeys.some(key => !distributionData[key]);
  }

  /** Verifica si hay más de un menor de un año por adulto */
  hasTooManyInfantsPerAdult(distributionData: DistributionPassengers): boolean {
    const infants = Object.keys(distributionData).filter(key => key.startsWith('minorAge') && distributionData[key] <= '1' && distributionData[key] != '').length;
    return infants > distributionData.adults;
  }

  /** Ejecuta todas las validaciones necesarias */
  validateDistributionData(distributionData: DistributionPassengers): boolean {
    this.showValidation = this.hasMinorWithoutAge(distributionData);
    this.hasTooManyInfantsValidation = this.hasTooManyInfantsPerAdult(distributionData);
    return this.showValidation || this.hasTooManyInfantsValidation;
  }

  getDistributionParameters(distributionData: DistributionPassengers): any {
    const minorAges = this.getMinorsAgeKeys(distributionData).map(key => parseInt(distributionData[key]));
    return {
      adults: distributionData.adults + minorAges.filter(age => age > 11).length,
      children: minorAges.filter(age => age > 1 && age < 12).length,
      infants: minorAges.filter(age => age < 2).length
    }
  }

  /** El parámetro "di" tiene el formato "adultos-niños:edadniño1-edadniño2..." Ejemplos: "1-0", "3-2:10-14", "2-1:8" */
  buildDiParam(distributionData: DistributionPassengers): string {
    const minorAges = this.getMinorsAgeKeys(distributionData).map(key => distributionData[key]);
    const base = `${distributionData.adults}-${distributionData.minors}`;
    return minorAges.length > 0 ? `${base}:${minorAges.join('-')}` : base;
  }
}
